import { storageHelper } from '@core-ui/utility';

export const modelToggleEngagementAdapter = () => {
  const { getItem } = storageHelper(localStorage);
  const sizeValue = getItem('size-model-toggle-label');
  return sizeValue ? `modelOn=size ${sizeValue}` : ''
};
